(() => {
  if (window.zippoCommercialForms) return;
  window.zippoCommercialForms = true;
  const initialized = new WeakSet();
  const controllers = new Map();
  const ttl = 30 * 60 * 1000;
  const prefix = 'zippo-quote:';
  const readDraft = key => {
    try {
      const value = JSON.parse(sessionStorage.getItem(key));
      if (value && Date.now() - value.time < ttl) return value;
      sessionStorage.removeItem(key);
    } catch (_) {}
    return null;
  };
  const clearDraft = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  function attach(context) {
    const form = context.closest('form');
    if (!form || initialized.has(form)) return;
    initialized.add(form);
    const key = prefix + location.pathname + ':' + form.id;
    const state = context.dataset.zqState;
    let feedback;
    const revealFeedback = feedback => {
      feedback.setAttribute('tabindex', '-1');
      feedback.focus({ preventScroll: true });
      feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
    };
    const realignFeedback = () => {
      if (!feedback || document.activeElement !== feedback) return;
      requestAnimationFrame(() => {
        if (document.activeElement === feedback) revealFeedback(feedback);
      });
    };
    const previous = form.querySelector('[data-zq-referrer]');
    if (previous && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === location.origin && referrer.pathname !== location.pathname) previous.value = referrer.origin + referrer.pathname;
      } catch (_) {}
    }
    const status = document.createElement('p');
    status.className = 'zq-help';
    status.setAttribute('role', 'status');
    status.hidden = true;
    form.append(status);
    const button = form.querySelector('[type=submit]');
    const buttonLabel = button?.innerHTML;
    let pending = false;
    let timer;
    const unlock = () => {
      if (state === 'success') return;
      pending = false;
      clearTimeout(timer);
      form.removeAttribute('aria-busy');
      if (button) { button.removeAttribute('aria-disabled'); button.innerHTML = buttonLabel; }
    };
    const customerFields = () => [...form.elements].filter(field => field.name?.startsWith('contact[') && !['hidden', 'file', 'submit'].includes(field.type));
    const syncVehicle = () => {
      const input = form.querySelector('[data-zq-vehicle]');
      const type = form.querySelector('[name="contact[tipo_mezzo]"]');
      if (!input || !type) return;
      const hints = { 'Furgone o flotta': 'van', 'Mezzo speciale': 'special', 'Auto': 'car', 'Camper': 'camper', 'Moto': 'moto' };
      input.placeholder = input.dataset['zqHint' + ((hints[type.value] || 'general').replace(/^./, c => c.toUpperCase()))];
    };
    const syncConditions = () => {
      syncVehicle();
      const installation = form.querySelector('[data-zq-installation]');
      const locationField = form.querySelector('[data-zq-location]');
      if (installation && locationField) {
        const active = installation.value === 'yes';
        locationField.hidden = !active;
        const input = locationField.querySelector('input');
        input.disabled = !active;
        input.required = active;
      }
    };
    const sync = () => {
      const root = form.closest('product-info') || form.closest('.shopify-section') || document;
      const productForm = root.querySelector('form[data-type="add-to-cart-form"], product-form form');
      const variantId = productForm?.querySelector('[name=id]')?.value || new URL(location.href).searchParams.get('variant');
      const variantsNode = context.querySelector('[data-zq-variants]');
      if (variantsNode) {
        let variants = [];
        try { variants = JSON.parse(variantsNode.textContent) || []; } catch (_) {}
        const variant = variants.find(item => String(item.id) === String(variantId || context.querySelector('[data-zq-variant-id]').value));
        if (variant) {
          context.querySelector('[data-zq-variant-id]').value = variant.id;
          context.querySelector('[data-zq-variant]').value = variant.title;
          const url = new URL(context.querySelector('[data-zq-url]').value, location.href);
          url.searchParams.set('variant', variant.id);
          context.querySelector('[data-zq-url]').value = url.href;
        }
        const quantity = [...root.querySelectorAll('[name=quantity]')].find(input => !productForm || input.form === productForm);
        const count = quantity?.value || '1';
        context.querySelector('[data-zq-quantity]').value = count;
        const options = [];
        if (productForm) {
          for (const [name, value] of new FormData(productForm)) {
            const match = name.match(/^properties\[(.+)\]$/);
            if (!match || match[1].startsWith('_') || typeof value !== 'string' || !value.trim()) continue;
            const line = match[1] + ': ' + value.trim();
            if (!options.includes(line)) options.push(line);
          }
        }
        context.querySelector('[data-zq-options]').value = options.join('\n');
      } else {
        const digitalUrl = form.querySelector('[data-zd-product-url]');
        if (digitalUrl?.value) context.querySelector('[data-zq-url]').value = digitalUrl.value;
      }
    };
    if (state === 'success') clearDraft(key);
    else {
      const draft = readDraft(key);
      if (draft) {
        for (const field of customerFields()) {
          const saved = draft.fields[field.name];
          if (saved === undefined) continue;
          if (['checkbox', 'radio'].includes(field.type)) field.checked = saved.includes(field.value);
          else field.value = saved[0] ?? '';
        }
        syncConditions();
        form.querySelector('[data-zd-service]')?.dispatchEvent(new Event('change', { bubbles: true }));
        if (state !== 'error') { status.hidden = false; status.textContent = context.dataset.zqUnconfirmed; }
      }
    }
    syncConditions();
    sync();
    form.addEventListener('change', syncConditions);
    form.addEventListener('submit', event => {
      if (state === 'success') { event.preventDefault(); return; }
      if (event.defaultPrevented) return;
      if (pending) { event.preventDefault(); return; }
      sync();
      const fields = {};
      for (const field of customerFields()) {
        if (['checkbox', 'radio'].includes(field.type) && !field.checked) continue;
        (fields[field.name] ||= []).push(field.value);
      }
      try { sessionStorage.setItem(key, JSON.stringify({time: Date.now(), fields})); } catch (_) {}
      pending = true;
      form.setAttribute('aria-busy', 'true');
      if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = context.dataset.zqSending; }
      status.hidden = true;
      timer = setTimeout(() => { unlock(); status.hidden = false; status.textContent = context.dataset.zqUnconfirmed; }, 25000);
      queueMicrotask(() => { if (event.defaultPrevented) unlock(); });
    });
    if (state !== 'idle') {
      form.closest('details')?.setAttribute('open', '');
      feedback = state === 'success' ? form.querySelector('[data-zq-success]') : form.querySelector('[role=alert]');
      let fragment = location.hash.slice(1);
      try { fragment = decodeURIComponent(fragment); } catch (_) {}
      const confirmationId = form.id + '-confirmation';
      const targetsForm = state !== 'success' || !fragment || fragment === form.id || fragment === confirmationId;
      if (feedback && targetsForm) {
        if (state === 'success') {
          feedback.id = confirmationId;
          try { history.replaceState(history.state, '', '#' + encodeURIComponent(confirmationId)); } catch (_) {}
        }
        feedback.setAttribute('tabindex', '-1');
        feedback.setAttribute('role', state === 'error' ? 'alert' : 'status');
        requestAnimationFrame(() => revealFeedback(feedback));
        if (document.readyState !== 'complete') window.addEventListener('load', realignFeedback, { once: true });
      }
    }
    controllers.set(form, {sync, unlock, realignFeedback});
  }
  function scan(root = document) {
    if (root.matches?.('[data-zq-context]')) attach(root);
    root.querySelectorAll?.('[data-zq-context]').forEach(attach);
    for (const form of controllers.keys()) if (!form.isConnected) controllers.delete(form);
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; for (const {sync} of controllers.values()) sync(); });
  };
  try { Object.keys(sessionStorage).filter(key => key.startsWith(prefix)).forEach(readDraft); } catch (_) {}
  scan();
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pageshow', () => { for (const {unlock, realignFeedback} of controllers.values()) { unlock(); realignFeedback(); } schedule(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
  }).observe(document.body, {childList: true, subtree: true});
})();
